import React from "react";
import { useNavigate } from "react-router-dom";
import "./scss/breadcrumbs.scss";

export default function Breadcrumbs({ items = [] }) {
  const navigate = useNavigate();

  return (
    <div className="breadcrumbs">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <span key={index} className="breadcrumbs__item">
            <span
              className={`breadcrumbs__link ${
                isLast ? "last" : ""
              }`}
              onClick={() => {
                if (!isLast && item.path)
                  navigate(item.path);
              }}
            >
              {item.label}
            </span>

            {!isLast && (
              <span className="breadcrumbs__separator">
                ›
              </span>
            )}
          </span>
        );
      })}
    </div>
  );
}
